module.exports = __webpack_public_path__ + "static/wpack/extracted/sunrise01b241831c49d06c4b67dfd0c86f4cfe.svg";